import { AssetResponseAssetType } from 'generatedTypes/asset/models';
import { useState } from 'react';

import AssetToggle from 'components/AssetToggle';
import BatteriesGrid from 'components/BatteriesGrid';
import DronesGrid from 'components/DronesGrid';
import DronesToolbar from 'components/DronesToolbar';
import Page from 'components/Page';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import KpiTiles from './components/KpiTiles';
import MaintenancePageHeader from './components/MaintenancePageHeader';
import { SHOW_PLURALIZED_LABELS, TEST_ID } from './constants';
import type { FunctionComponent, KpiCard, Props } from './types';

import styles from './styles.module.scss';

const MaintenancePage: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => {
    const { DRONES_BREAKDOWN, TITLE, TOTAL_DRONES } = useTranslation();
    const { activeDrones, drones, fetchNextPage, groundedDrones, hasMore, onSearch, totalDrones } =
        useData();

    const [selectedAssetType, setSelectedAssetType] = useState<AssetResponseAssetType>(
        AssetResponseAssetType.DRONE
    );

    const isDroneView = selectedAssetType === AssetResponseAssetType.DRONE;

    const kpiCards: KpiCard[] = [
        {
            key: 'totalDrones',
            subtext: DRONES_BREAKDOWN({ active: activeDrones, grounded: groundedDrones }),
            title: TOTAL_DRONES,
            value: String(totalDrones)
        }
    ];

    return (
        <Page className={`${className} ${styles.maintenancePage}`} testId={testId}>
            <MaintenancePageHeader className={styles.pageHeader} title={TITLE} />

            <KpiTiles items={kpiCards} />

            <AssetToggle
                assetType={selectedAssetType}
                className={styles.assetToggle}
                onChange={setSelectedAssetType}
                pluralize={SHOW_PLURALIZED_LABELS}
            />

            {isDroneView ? (
                <>
                    <DronesToolbar onSearch={onSearch} />

                    <DronesGrid
                        className={styles.assetGrid}
                        onNext={hasMore ? fetchNextPage : undefined}
                        rows={drones}
                    />
                </>
            ) : (
                <BatteriesGrid className={styles.assetGrid} />
            )}
        </Page>
    );
};

export default MaintenancePage;
